import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FromAndTo } from '@com-delta-omnichannel/mach-core-js';
import { Select_Different_Airport } from '../constants/vacation-widget.constants';
import {
  VacationWidget,
  VacationWidgetFormType
} from '../models/vacation-widget.interfaces';
@Injectable({
  providedIn: 'root'
})
export class FormValidationService {
  setMaxDateError(
    form: FormGroup<VacationWidgetFormType>,
    content: VacationWidget
  ): string {
    return form.controls['returnDate'].hasError('maxDateMismatch')
      ? content.labels.maxDatesErrorLabel
      : '';
  }

  setDateError(
    form: FormGroup<VacationWidgetFormType>,
    content: VacationWidget
  ): string {
    const isDepartDateInvalid = form.controls['departDate'].invalid;
    const isReturnDateInvalid = form.controls['returnDate'].invalid;

    return isDepartDateInvalid || isReturnDateInvalid
      ? content.labels.datesAreRequiredErrorLabel
      : '';
  }

  setPassengerError(
    form: FormGroup<VacationWidgetFormType>,
    content: VacationWidget
  ): string {
    return form.controls['numberOfPassengers'].hasError('passengerRoomMismatch')
      ? content.labels.tooFewPeopleErrorLabel
      : '';
  }

  setAirportError(
    form: FormGroup<VacationWidgetFormType>,
    airportPicker: FromAndTo,
    content: VacationWidget,
    isSubmitted = false
  ): string {
    const isOriginInvalid = form.controls['destinationAirportCode'].invalid;
    const isDestinationInvalid = form.controls['originAirportCode'].invalid;
    const hasSameAirports =
      airportPicker.isValid().errors.destination === Select_Different_Airport;

    if (isSubmitted) {
      airportPicker.setDestinationError(isOriginInvalid);
      airportPicker.setOriginError(isDestinationInvalid);

      if (hasSameAirports) {
        airportPicker.setDestinationError(hasSameAirports);
        airportPicker.setOriginError(hasSameAirports);
      }
    }

    return this.getAirportErrorMessage(
      isOriginInvalid,
      isDestinationInvalid,
      content,
      hasSameAirports
    );
  }

  private getAirportErrorMessage(
    isOriginInvalid: boolean,
    isDestinationInvalid: boolean,
    content: VacationWidget,
    hasSameAirports = false
  ): string {
    if (hasSameAirports) {
      return content.labels.selectDifferentAirportErrorLabel;
    }

    const errorMap = {
      [`${true}_${true}`]: content.labels.originAndDestinationErrorLabel,
      [`${true}_${false}`]: content.labels.destinationErrorLabel,
      [`${false}_${true}`]: content.labels.originErrorLabel
    };

    return errorMap[`${isOriginInvalid}_${isDestinationInvalid}`] || '';
  }
}
